import { ReactComponent as Logo } from "../assets/logos/appara_logo.svg";
import { useNavigate } from "react-router-dom";

import styles from "./styles/header.module.scss";
import { useState } from "react";
import { HamburgerMenu, SidebarMenu } from "./hamburger_menu";

export const Header = () => {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className={styles.webHeader}>
        <button className={styles.contactUs} onClick={() => navigate("/products")}>
          Contact us
        </button>
        <div className={styles.logo} onClick={() => navigate("/")}>
          <Logo />
        </div>
        <button className={styles.airQuality} onClick={() => navigate("/calculator")}>
          Check your air quality
        </button>
      </div>
      {/* THIS PART IS FOR MOBILE PHONES */}
      <div className={styles.mobileHeader}>
        <div className={styles.logo} onClick={() => navigate("/")}>
          <Logo />
        </div>
        <nav className={styles.navbar}>
          <HamburgerMenu onClick={toggleMenu} />
        </nav>
        <SidebarMenu isOpen={menuOpen} onClose={closeMenu} />
      </div>
    </>
  );
};
